var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticStyle: { padding: "50px 16px", "background-color": "#2D2D2D" } },
    [
      _c("el-col", { attrs: { span: 24 } }, [
        _c("img", {
          staticClass: "background-image",
          attrs: {
            loading: "lazy",
            src: require("../../assets/AgentLoginBackground.jpg")
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "backdrop" },
          [
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { span: 24 } }, [
                  _c("span", { staticClass: "sign-in-lbl" }, [
                    _vm._v("Successful Verification")
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { staticStyle: { width: "100%", "margin-top": "16px" } },
              [
                _c(
                  "el-col",
                  {
                    staticStyle: {
                      "padding-bottom": "16px",
                      display: "flex",
                      "flex-direction": "column"
                    },
                    attrs: { span: 24 }
                  },
                  [
                    _c("span", { staticClass: "para-style" }, [
                      _vm._v("Your email address is verified.")
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { staticStyle: { width: "100%" } },
              [
                _c(
                  "el-col",
                  {
                    staticStyle: {
                      "padding-bottom": "16px",
                      display: "flex",
                      "flex-direction": "column"
                    },
                    attrs: { span: 24 }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn-primary",
                        on: { click: _vm.redirectToLoginPage }
                      },
                      [_vm._v("Login")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-abd5191e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abd5191e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reset/resetSuccessSection.vue
// module id = null
// module chunks = 